<div class="gridItemChildModule w-100 h-100 d-flex flex-column">
    <!-- Search -->
    <div class="w-75 mx-auto my-2 search-box live-search" [hidden]="!showFilter">
        <input type="search" class="form-control"
            autocomplete="off"
            [(ngModel)]="filterValue"
            (ngModelChangeDebounced)="applyFilter()"
            [ngModelChangeDebounceTime]="500"
            placeholder="Search..."
            cvLocalizedPlaceholder
            [langSection]="'Subscriptions_Management'"
            [langKey]="'Search'"
        />
        <span class="clear-input" role="button" tabindex="0"
            [hidden]="filterValue.length === 0"
            (click)="clearFilter()">
        </span>
    </div>
    <app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
    <div class="h-100 flex-fill" *ngIf="!noData" style="overflow-y: auto;">
        <ag-grid-angular
            #bancoItauWidgetGrid
            *ngIf="gridOptions !== null && !noData"
            class="ag-theme-balham h-100"
            [gridOptions]="gridOptions"
            [defaultColDef]="gridOptions.defaultColDef">
        </ag-grid-angular>
    </div>
</div>